<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-row>
          <v-col cols="auto" class="my-auto" v-if="$vuetify.breakpoint.mdAndUp">
            <v-card-text class="ml-8">
              <v-img :src="image" height="50" contain v-if="image"></v-img>
              <v-icon size="50" color="secondary" v-else-if="icon">
                {{ icon }}
              </v-icon>
              <user-avatar v-else-if="userAvatar" :user="userAvatar" size="60">
              </user-avatar>
            </v-card-text>
          </v-col>
          <v-col class="my-auto">
            <v-card-title>
              {{ title }}
              <slot name="titleExtension"></slot>
            </v-card-title>
            <v-card-subtitle>
              <template v-if="!$slots.subTitle">
                {{ subTitle }}
              </template>
              <slot name="subTitle"></slot>
            </v-card-subtitle>
          </v-col>
          <template v-if="$slots.right">
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-card-text class="py-0">
                <slot name="right"></slot>
              </v-card-text>
            </v-col>
          </template>
          <template v-if="$slots.right2">
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-card-text class="py-0">
                <slot name="right2"></slot>
              </v-card-text>
            </v-col>
          </template>
        </v-row>
        <slot name="extension"></slot>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "HeaderCard",
  props: {
    icon: { type: String },
    image: { type: String },
    title: { type: String },
    subTitle: { type: String },
    userAvatar: { type: Object }
  }
};
</script>
